import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconStar: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg
        aria-hidden="true"
        className={`icon-component ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path className="stroke" d="m12 2 3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01Z" />
    </svg>
)
